import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Textbox from "components/Forms/Elements/Textbox";
import Selectbox from "components/Forms/Elements/Selectbox";
import hasProperty from "lodash/has";
import Notification from "components/Notification";
import Translate from "helpers/Translate";

function Accuracy(props) {
  const [customErrors, setCustomErrors] = useState({});

  useEffect(() => {
    setCustomErrors({});
    if (hasProperty(props, "errors.response.data.data.errors")) {
      props.errors.response.data.data.errors.forEach(element => {
        if (
          element.field === "accuracy_conditions" &&
          element.validation !== "min"
        ) {
          let message;
          try {
            message = JSON.parse(element.message);
            for (const iterator of message) {
              iterator.field = `${iterator.field}_${iterator.uuid}`;
            }
          } catch (error) {}

          setCustomErrors({
            response: {
              data: {
                data: {
                  errors: message
                }
              }
            }
          });
          return;
        }
      });
    }
  }, [props]);

  return (
    <div className="condition my-10">
      <div className="form-group">
        <div
          className="row"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <label>{Translate({ id: "if_accuracy_percentage" })} </label>
          <i
            title="Remove Condition"
            className="far fa-trash-alt pointer"
            onClick={() => {
              Notification.confirm(
                Translate({ id: "sure_to_delete_this_accuracy_condition" }),
                {
                  onOk: () => {
                    props.onRemove();
                  }
                }
              );
            }}
          ></i>
        </div>
        <div className="row mt-10">
          <Selectbox
            name="accuracy_from"
            id="operator"
            onChange={e => props.onChange(e)}
            errors={customErrors}
            errorKey={`accuracy_from_operator_${props.item.uuid}`}
            classes="form-input mr-20"
            fieldValue={props?.fieldValue?.accuracy_from?.operator}
            options={[
              {
                label: Translate({ id: "select_operator" }),
                value: ""
              },
              {
                label: Translate({ id: "greater_than" }),
                value: ">"
              },
              {
                label: Translate({ id: "greater_than_equals" }),
                value: ">="
              }
            ]}
          />
          <Textbox
            type="number"
            placeholder="10"
            id="value"
            name="accuracy_from"
            fieldValue={props?.fieldValue?.accuracy_from?.value}
            classes="form-input-sm mr-5"
            onChange={e => props.onChange(e)}
            onReturnKey={e => props.onReturnKey()}
            errors={customErrors}
            errorKey={`accuracy_from_value_${props.item.uuid}`}
            formErrorClass="form-error"
          />{" "}
          <span className="symbol">%</span>
        </div>
        <div className="and my-20">{Translate({ id: "and" })} </div>
        <div className="row">
          <Selectbox
            name="accuracy_to"
            id="operator"
            classes="form-input mr-20"
            fieldValue={props?.fieldValue?.accuracy_to?.operator}
            onChange={e => props.onChange(e)}
            errors={customErrors}
            errorKey={`accuracy_to_operator_${props.item.uuid}`}
            options={[
              {
                label: Translate({ id: "select_operator" }),
                value: ""
              },
              {
                label: Translate({ id: "less_than" }),
                value: "<"
              },
              {
                label: Translate({ id: "less_than_equals" }),
                value: "<="
              }
            ]}
          />
          <Textbox
            type="number"
            placeholder="100"
            id="value"
            name="accuracy_to"
            fieldValue={props?.fieldValue?.accuracy_to?.value}
            classes="form-input-sm mr-5"
            onChange={e => props.onChange(e)}
            onReturnKey={e => props.onReturnKey()}
            errors={customErrors}
            errorKey={`accuracy_to_value_${props.item.uuid}`}
            formErrorClass="form-error"
          />{" "}
          <span className="symbol">%</span>
        </div>
      </div>
      <div className="then my-20">{Translate({ id: "then" })} </div>
      <div className="form-group ">
        <div className="row">
          <label className="mr-10">{Translate({ id: "quality_check" })} </label>
          <Textbox
            type="number"
            placeholder="75"
            id="qc_value"
            name="qc_value"
            fieldValue={props.fieldValue.qc_value}
            classes="form-input-sm mr-5"
            onChange={e => props.onChange(e)}
            onReturnKey={e => props.onReturnKey()}
            errors={customErrors}
            errorKey={`qc_value_${props.item.uuid}`}
            formErrorClass="form-error"
          />
          <span className="symbol">%</span>
        </div>
      </div>
    </div>
  );
}

Accuracy.propTypes = {
  props: PropTypes.object
};

export default Accuracy;
